var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTimeline = function SvgTimeline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 375,
    viewBox: "0 0 1 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.499512,
    y1: -2.18557e-8,
    x2: 0.499528,
    y2: 375,
    stroke: "#959595",
    strokeMiterlimit: 16,
    strokeDasharray: "8 8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimeline);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIzNzUiIHZpZXdCb3g9IjAgMCAxIDM3NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjAuNDk5NTEyIiB5MT0iLTIuMTg1NTdlLTA4IiB4Mj0iMC40OTk1MjgiIHkyPSIzNzUiIHN0cm9rZT0iIzk1OTU5NSIgc3Ryb2tlLW1pdGVybGltaXQ9IjE2IiBzdHJva2UtZGFzaGFycmF5PSI4IDgiLz4KPC9zdmc+Cg==";